const SubscriptionStatus = {
	INITIAL: 'initial', // Initial status, before first payment
	ACTIVE: 'active', // When subscription is active and valid, regardless if auto renew is on or off
	EXPIRED: 'expired', // When subscription is no longer valid, needs renew
} as const;

export default SubscriptionStatus;
